export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-06.b53af6a5.jpg";